var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:{
            'zoom-button': true,
            'is-selected': _vm.isSelected,
            'is-pyramid-level': _vm.shouldHighlightPyramid && _vm.isPyramidLevel,
            'is-digital': _vm.isDigital
          },style:(_vm.style),attrs:{"size":"sm","title":_vm.isDigital ? _vm.$t('digital-hover') : ''},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }